import { DynamicHighlight } from 'src/constants/assemblyJourneys';
import { ISection } from 'src/interfaces';

export const getDynamicSections = (sections: ISection[]) =>
  sections.filter((section) =>
    [
      DynamicHighlight.SECTION_ROTATION,
      DynamicHighlight.TAKE_OVER,
      DynamicHighlight.OUTDOOR,
    ].includes(section.config?.dynamicHighlight!),
  );
